import { createAsyncThunk } from '@reduxjs/toolkit'
import { ManagementService } from '../Management/ManagementService'
import { ChannelSettingsDTO, createUserRequestDTO } from '../Management/ManagementModel'

const managementService = new ManagementService()

export const getAllCompanies = createAsyncThunk('companies/getList', async () => {
    const dataCompanies = await managementService.getCompanies()
    return dataCompanies
})
export const getByIdCompany = createAsyncThunk('companies/getSingle', async (companyId: string) => {
    const dataCompanyId = await managementService.getCompanyById(companyId)
    return dataCompanyId
})
export const getAllCompaniesChildren = createAsyncThunk('companies/getListChildren', async () => {
    const dataCompaniesChildren = managementService.getCompaniesChildren()
    return dataCompaniesChildren
})
export const getAllUsers = createAsyncThunk('users/list', async () => {
    const dataUsers = managementService.getUser()
    return dataUsers
})
export const createUser = createAsyncThunk(
    'users/create',
    async ({ data, onSuccess, onError }: { data: createUserRequestDTO; onSuccess?: () => void; onError?: () => void }) => {
        try {
            const createOneUser = await managementService.postUser(data)
            if (onSuccess) onSuccess()
            return createOneUser
        } catch {
            if (onError) onError()
        }
    }
)
export const updateUser = createAsyncThunk(
    'users/update',
    async ({
        userId,
        data,
        onSuccess,
        onError
    }: {
        userId: string
        data: createUserRequestDTO
        onSuccess?: () => void
        onError?: () => void
    }) => {
        try {
            const updateOneUser = await managementService.putUser(userId, data)
            if (onSuccess) onSuccess()
            return updateOneUser
        } catch {
            if (onError) onError()
        }
    }
)
export const deleteUser = createAsyncThunk('users/delete', async (userId: string) => {
    const deleteOneUser = managementService.deleteUser(userId)
    return deleteOneUser
})
export const exportAllUsers = createAsyncThunk('users/exportAll', async (format: 'CSV' | 'XLSX', { rejectWithValue }) => {
    try {
        await managementService.getUserExport(format)
    } catch (error: any) {
        return rejectWithValue(error.message || 'Export failed')
    }
})
export const getAllSites = createAsyncThunk('sites/list', async () => {
    const listSites = managementService.getSite()
    return listSites
})
export const exportSiteCompany = createAsyncThunk(
    'sites/exportAll',
    async (data: { format: 'CSV' | 'XLSX'; societeId?: string }, { rejectWithValue }) => {
        try {
            await managementService.getSiteExport(data.format, data.societeId)
        } catch (error: any) {
            return rejectWithValue(error.message || 'Export failed')
        }
    }
)
export const exportSiteById = createAsyncThunk(
    'sites/exportById',
    async (data: { siteId: string; format: 'CSV' | 'XLSX' }, { rejectWithValue }) => {
        try {
            await managementService.getSiteExportById(data.siteId, data.format)
        } catch (error: any) {
            return rejectWithValue(error.message || 'Export failed')
        }
    }
)
export const getAllCatalogs = createAsyncThunk('catalogs/list', async () => {
    const dataCatalogs = managementService.getCatalog()
    return dataCatalogs
})
export const updateCatalogDM = createAsyncThunk('catalogs/updateDM', async (data: { catalogId: string; data: ChannelSettingsDTO }) => {
    const updateOneCatalog = managementService.putCatalog(data.catalogId, data.data)
    return updateOneCatalog
})
export const updateCatalogYT = createAsyncThunk('catalogs/updateYT', async (data: { catalogId: string; data: ChannelSettingsDTO }) => {
    const updateOneCatalog = managementService.putCatalog(data.catalogId, data.data)
    return updateOneCatalog
})

export const exportCatalogById = createAsyncThunk(
    'catalogs/exportById',
    async (data: { catalogId: string; format: 'CSV' | 'XLSX' }, { rejectWithValue }) => {
        try {
            await managementService.getCatalogExportId(data.catalogId, data.format)
        } catch (error: any) {
            return rejectWithValue(error.message || 'Export failed')
        }
    }
)
export const exportCatalog = createAsyncThunk('catalogs/export', async (format: 'CSV' | 'XLSX') => {
    try {
        await managementService.getCatalogExport(format)
    } catch {
        return 'Export failed'
    }
})
export const getAllRoles = createAsyncThunk('roles/list', async () => {
    const dataRoles = managementService.getRole()
    return dataRoles
})
export const sendResetPwd = createAsyncThunk(
    'users/sendResetPasswordLink',
    async ({ email, onSuccess, onError }: { email: string; onSuccess?: () => void; onError?: () => void }) => {
        try {
            const result = await managementService.resetPwd(email)
            if(onSuccess) onSuccess()
            return result
        } catch (error: any) {
            if(onError) onError()
        }
    }
)

